import React from "react";
import {  useState,useEffect,useRef } from 'react';
import Navbar from "./Home/Navbar";
import Hero from "./Home/Hero";
import About from "./Home/About";
import Services from "./Home/Services";
import Projects from "./Home/Projects";
import Contact from "./Home/Contact";
import Footer from "./Home/Footer";
import Icons from "./Home/Icons";
import ParticlesBackground from "./Home/ParticlesBackground";

function App() {
// Toggle Theme 
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    const savedTheme = localStorage.getItem("darkMode") === "true";
    setDarkMode(savedTheme);
  }, []);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
      document.body.classList.remove("light-mode");
    } else {
      document.body.classList.add("light-mode");
      document.body.classList.remove("dark-mode");
    }
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);
// End Toggle Theme

// scroll nav and active link 
const mainRef = useRef(null);
const aboutRef = useRef(null);
const servicesRef = useRef(null);
const contactRef = useRef(null);
const projectsRef = useRef(null);


const scrollToSection = (ref) => {
  if (ref?.current) {
    window.scrollTo({
      top: ref.current.offsetTop - 50, // طرح ارتفاع النافبار
      behavior: "smooth",
    });
  }
};


// Active link if needed
  const [activeSection, setActiveSection] = useState("");
  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        { ref: mainRef, id: "main" },
        { ref: aboutRef, id: "about" },
        { ref: servicesRef, id: "services" },
        { ref: projectsRef, id: "projects" },
        { ref: contactRef, id: "contact" },
      ];

      for (const section of sections) {
        if (section.ref.current) {
          const rect = section.ref.current.getBoundingClientRect();
          if (rect.top >= 0 && rect.top < window.innerHeight / 4) {
            setActiveSection(section.id);
            break;
          }
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  return ( 
    <>
    <ParticlesBackground darkMode={darkMode} />
    <div id="main" ref={mainRef}>
      <Navbar darkMode={darkMode} setDarkMode={setDarkMode}
              scrollToSection={scrollToSection}
              mainRef={mainRef}
              aboutRef={aboutRef}
              servicesRef={servicesRef}
              contactRef={contactRef}
              projectsRef={projectsRef}
              activeSection={activeSection}
              />
      <Icons  darkMode={darkMode}/>        

      <Hero   darkMode={darkMode} />

      <About  darkMode={darkMode} 
              ref={aboutRef}/>
      
      <Services darkMode={darkMode} 
                ref={servicesRef} />

      <Projects darkMode={darkMode} 
                ref={projectsRef} />

      <Contact darkMode={darkMode} 
                scrollToSection={scrollToSection}
                ref={contactRef}
                servicesRef={servicesRef}
                />
      <Footer darkMode={darkMode} />          

      {/* <MouseEffect />           */}
    </div>
    </>
  );
}

export default App;
